
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/obzory-na-tovary/[code]",
      function () {
        return require("private-next-pages/obzory-na-tovary/[code].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/obzory-na-tovary/[code]"])
      });
    }
  